import styled, { css, keyframes } from "styled-components";

export const UserTimer1Wrapper = styled.div`
  overflow: hidden;
  padding: 30px;
  background: rgba(10, 9, 46, 0.8);
  display: flex;
  flex-direction: row;
  gap: 20px;
  max-width: 1920px;
  width: 100%;
  max-height: 1080px;
  height: 100%;
  box-sizing: border-box;
`;

export const Timer3Background = styled.div<{ backgroundImage: string }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ backgroundImage }) =>
    `url(${backgroundImage}) lightgray 50% / cover no-repeat`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  filter: blur(2.5px);
  opacity: 0.4;
`;

export const UserTimer1LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 2;
  max-width: 1104px;
  flex: 1.5;
`;

export const UserTimer1TimerInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 594px;
  padding: 0 38px;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  position: relative;

  > .title {
    margin-top: 30px;
    color: #fff;
    font-family: Pretendard;
    font-size: 45.203px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }

  > .bottom {
    position: absolute;
    bottom: 20px;
    width: calc(100% - 76px);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 40px;

    > .item {
      display: flex;
      flex-direction: row;
      gap: 30px;
      align-items: center;

      > .title {
        color: #a5a5a5;
        text-align: center;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .value {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      > .value2 {
        color: #fff;
        text-align: center;
        font-family: Pretendard;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        width: 130px;
      }
    }
  }
`;

export const UserTimer1TimerInfoTime = styled.div<{ isBreak: boolean }>`
  color: ${({ isBreak }) => (isBreak ? "#f00" : "#b6ffac")};
  font-family: Pretendard;
  font-size: 330px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  text-align: center;
  width: 100%;
  min-width: 998px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum" 1;
`;

export const UserTimer1TimerInfoNowLevel = styled.div`
  margin-top: 17px;
  max-width: 1034px;
  height: 88px;
  border-radius: 35px;
  background: #303030;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 60px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;

  > .break-text {
    color: #f00;
  }
`;

export const UserTimer1TimerInfoHeader = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  gap: 25px;
  align-items: center;
  justify-content: space-between;

  > .left {
    display: flex;
    flex-direction: row;
    gap: 25px;
    > img {
      width: 87px;
      height: 87px;
      border-radius: 100%;
      object-fit: cover;
    }
    > .info-row {
      display: flex;
      flex-direction: column;
      gap: 3px;
      justify-content: center;

      > .title {
        color: #fff;
        font-family: Pretendard;
        font-size: 35px;
        font-style: normal;
        font-weight: 900;
        line-height: normal;
      }

      > .type {
        color: #fff;
        font-family: Pretendard;
        font-size: 35px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }

  .pub-name {
    font-size: 35px;
    font-weight: 500;
    color: white;
  }
`;

export const UserTimer1BreakWrapper = styled.div`
  max-width: 1104px;
  height: 93px;
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  justify-content: center;
  border-radius: 35px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  > .title {
    color: #7a7a7b;
    text-align: center;
    font-family: Pretendard;
    font-size: 45.203px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .value {
    width: 218px;
    color: #fff;
    font-family: Pretendard;
    font-size: 45.203px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }
`;

export const UserTimer1BlindWrapper = styled.div`
  max-width: 1104px;
  height: 137px;
  display: flex;
  flex-direction: row;
  gap: 39px;
  border-radius: 35px;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  > .title {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 45px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }

  > .title.next {
    color: #979797;
  }

  > .value.next {
    color: #979797;
  }

  > .value {
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 70px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }
`;

export const UserTimer1RightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
  width: 100%;
`;
